// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DFMControls_container__6dnWm {
}
.DFMControls_button__\\+E7El {
  padding: 0.5em;
  justify-content: space-between;
  /* color: var(--danger1); */
  text-transform: none;
  border: 1px solid grey;
  /* border-radius: 0 !important;*/
  border-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreeJS/DFMControls/DFMControls.module.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;AAC1B","sourcesContent":[".container {\n}\n.button {\n  padding: 0.5em;\n  justify-content: space-between;\n  /* color: var(--danger1); */\n  text-transform: none;\n  border: 1px solid grey;\n  /* border-radius: 0 !important;*/\n  border-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DFMControls_container__6dnWm`,
	"button": `DFMControls_button__+E7El`
};
export default ___CSS_LOADER_EXPORT___;
